import { Controller } from "@hotwired/stimulus"

// Previne o submit duplicado em forms de página inteira (data-turbo="false"),
// onde o Turbo não desabilita o botão sozinho como faz nos forms comuns.
//
// Cobre dois cenários:
//   - o duplo-clique do usuário enquanto o servidor processa o login;
//   - o auto-submit de gerenciadores de senha (ex.: 1Password), que preenchem
//     os campos e já disparam o submit deixando o botão ainda ativo — o usuário
//     apressado clica nele em seguida.
//
// Sem isso, o segundo POST reenvia o mesmo CSRF token e o Rails responde 422.
//
// Uso no <form>:
//   data-controller="prevent-double-submit"
//   data-action="submit->prevent-double-submit#guard"
export default class extends Controller {
  connect() {
    this.submitting = false
  }

  guard(event) {
    if (this.submitting) {
      // Já há um submit em andamento: bloqueia o segundo. É esta linha que
      // evita o 422 — o feedback visual abaixo é secundário.
      event.preventDefault()
      return
    }

    this.submitting = true

    // Desabilita o botão apenas para feedback visual, num tick posterior, para
    // não interferir na serialização do form neste submit de página inteira.
    // setTimeout (e não requestAnimationFrame) para disparar de forma confiável
    // mesmo em aba em segundo plano, onde o rAF é suspenso.
    setTimeout(() => this.disableSubmitButtons(), 0)
  }

  disableSubmitButtons() {
    const buttons = this.element.querySelectorAll(
      'button[type="submit"], input[type="submit"]'
    )
    buttons.forEach((button) => {
      button.disabled = true
      button.setAttribute("aria-disabled", "true")
    })
  }
}
